import type { BooleanFlag } from './baseTypes';

export enum MemberStatus {
  forbidden = 0, // 禁止
  legal = 1, // 合法
  unauthorized = 2, // 未验证
}

export interface Member {
  cert: BooleanFlag;
  expireDate: number;
  expired: BooleanFlag;
  lastLogin: number;
  popularity: number;
  property: MemberProperty;
  signed: BooleanFlag;
  status: MemberStatus;
}
export interface MemberProperty {
  avatar: string;
  cityId: number;
  cityName: string;
  config: object;
  createDate: number;
  email: string;
  id: number;
  jobId: number;
  jobName: string;
  mobile: string;
  modHashId: string;
  nickname: string;
  remark: string;
  uid: string;
  updateDate: number;
  wxUnionid: string;
}
